import * as ActionTypes from '../actions/actionTypes';
import mapConfig from '../config/map_settings';

const initialState = {
  map_center: mapConfig.settings.center,
  map_zoom: mapConfig.settings.initialZoom,
  min_zoom: mapConfig.settings.minZoomDesktop,
  max_zoom: mapConfig.settings.maxZoom,
  minimal_controls: false,
  map_bounds: null,
  recentre_map: false,
  cursorPoint: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_MAP_CENTER:
      if (!action.map_center[0] || !action.map_center[1]) {
        return state;
      } else {
        return {
          ...state,
          map_center: action.map_center
        };
      }
    case ActionTypes.SET_CURSOR_POINT:
      return {
        ...state,
        cursorPoint: action.latlng
      };
    case ActionTypes.SET_MAP_BOUNDS_AND_ZOOM:
      return {
        ...state,
        map_zoom: (action.map_zoom && parseInt(action.map_zoom, 10)) ? action.map_zoom : state.map_zoom,
        map_bounds: action.map_bounds ? action.map_bounds : state.map_bounds
      };

    case ActionTypes.SET_MAP_MIN_ZOOM:
      return {
        ...state,
        min_zoom: (action.min_zoom && parseInt(action.min_zoom, 10)) ? action.min_zoom : state.min_zoom
      };

    case ActionTypes.SET_MAP_MIN_CONTROLS :
      return {
        ...state,
        minimal_controls: true
      };

    case ActionTypes.OPEN_GRAPHS_VIEW:
    case ActionTypes.CLOSE_GRAPHS_VIEW:
    case ActionTypes.TOGGLE_GRAPHS_EXPANDED:
    case ActionTypes.TOGGLE_POINT_DATA_DISPLAY:
    case ActionTypes.SELECT_DATA_SET:
    case ActionTypes.GRAPH_DATA_LOADED:
    case ActionTypes.SET_SHOW_WEATHER:
      return {
        ...state,
        recentre_map: true
      };

    case ActionTypes.MAP_RECENTRED:
      return {
        ...state,
        recentre_map: false
      };

    case ActionTypes.RESET_MAP:
      return {
        ...state,
        map_zoom: mapConfig.settings.initialZoom,
        map_center: mapConfig.settings.center
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/map.js